var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择年月",
            visible: _vm.monthDialogVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.monthDialogVisible = $event
            }
          }
        },
        [
          _c("el-date-picker", {
            staticStyle: { width: "100%" },
            attrs: {
              type: "month",
              placeholder: "请选择年月",
              format: "yyyy-MM",
              "value-format": "yyyy-MM"
            },
            model: {
              value: _vm.selectedMonth,
              callback: function($$v) {
                _vm.selectedMonth = $$v
              },
              expression: "selectedMonth"
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.monthDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleMonthConfirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "150px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "业务工单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入业务工单号" },
                              model: {
                                value: _vm.searchForm.TicketId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "TicketId", $$v)
                                },
                                expression: "searchForm.TicketId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "对账年月" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "month",
                                placeholder: "请选择年月",
                                format: "yyyy-MM",
                                "value-format": "yyyy-MM"
                              },
                              model: {
                                value: _vm.searchForm.Month,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "Month", $$v)
                                },
                                expression: "searchForm.Month"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单是否超时" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.isDelayCause,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "isDelayCause",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.isDelayCause"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "是", value: true }
                                }),
                                _c("el-option", {
                                  attrs: { label: "否", value: false }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO订单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入PO订单号" },
                              model: {
                                value: _vm.searchForm.orderNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "orderNo", $$v)
                                },
                                expression: "searchForm.orderNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO分派单单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入PO分派单单号" },
                              model: {
                                value: _vm.searchForm.it_po_opTicketid,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "it_po_opTicketid",
                                    $$v
                                  )
                                },
                                expression: "searchForm.it_po_opTicketid"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO计费单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入PO计费单号" },
                              model: {
                                value: _vm.searchForm.cost_confirm_opTicketid,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "cost_confirm_opTicketid",
                                    $$v
                                  )
                                },
                                expression: "searchForm.cost_confirm_opTicketid"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO计费单状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.billState,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "billState", $$v)
                                  },
                                  expression: "searchForm.billState"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "全额", value: "全额" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "7折", value: "7折" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "不计费", value: "不计费" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "结单人中文名" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入结单人中文名" },
                              model: {
                                value: _vm.searchForm.engineerName,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "engineerName", $$v)
                                },
                                expression: "searchForm.engineerName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "自动核对状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择自动核对状态"
                                },
                                model: {
                                  value: _vm.searchForm.autoCheckStatus,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "autoCheckStatus",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.autoCheckStatus"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "正常", value: "正常" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "异常", value: "异常" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "手动核对状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择手动核对状态"
                                },
                                model: {
                                  value: _vm.searchForm.manualCheckStatus,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "manualCheckStatus",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.manualCheckStatus"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "正常", value: "1" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "异常", value: "0" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "确认结果" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择确认结果"
                                },
                                model: {
                                  value: _vm.searchForm.confirm_result,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "confirm_result",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.confirm_result"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "正常", value: "正常" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "异常", value: "异常" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "未确认", value: "null" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("账单核对")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c("div", { staticClass: "button-container" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.loading },
                      on: {
                        click: function($event) {
                          return _vm.showMonthDialog("autoCheck")
                        }
                      }
                    },
                    [_vm._v("自动核对")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", disabled: _vm.loading },
                      on: {
                        click: function($event) {
                          return _vm.showMonthDialog("batchDispatch")
                        }
                      }
                    },
                    [_vm._v("派发已标记异常工单进行核对")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", disabled: _vm.loading },
                      on: {
                        click: function($event) {
                          return _vm.showMonthDialog("returnToTencent")
                        }
                      }
                    },
                    [_vm._v("对账信息返回腾讯")]
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                    _vm._v("表头设置")
                  ])
                ],
                1
              )
            ]),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.faults, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      width: column.width,
                      "header-style": {
                        "white-space": "normal",
                        "word-break": "break-all",
                        height: "auto",
                        "line-height": "1.2",
                        padding: "8px 0"
                      },
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === "isDelayCause"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.isDelayCause == true
                                          ? "是"
                                          : "否"
                                      )
                                    )
                                  ])
                                : column.prop === "completeTime" ||
                                  column.prop === "billCompleteTime"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row[column.prop]
                                          ? _vm
                                              .$moment(scope.row[column.prop])
                                              .format("YYYY-MM-DD HH:mm:ss")
                                          : ""
                                      )
                                    )
                                  ])
                                : column.prop === "cost_confirm_opTicketid"
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                            scope.row.cost_confirm_opTicketid +
                                            "&isHistory=1",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.cost_confirm_opTicketid ||
                                              "-"
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : column.prop === "it_po_opTicketid"
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                            scope.row.it_po_opTicketid +
                                            "&isHistory=1",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.it_po_opTicketid || "-"
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : column.prop === "manualCheckTicket"
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: scope.row.manualCheckStatus
                                            ? "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                              scope.row.manualCheckTicket +
                                              "&isHistory=1"
                                            : "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                              scope.row.manualCheckTicket,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.manualCheckTicket || "-"
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : column.prop === "autoCheckStatus"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row[column.prop] === "正常"
                                            ? "success"
                                            : scope.row[column.prop] === "异常"
                                            ? "danger"
                                            : "info",
                                        size: "mini"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row[column.prop] || "未知"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "manualCheckStatus"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row[column.prop] === "1"
                                            ? "success"
                                            : scope.row[column.prop] === "0"
                                            ? "danger"
                                            : "info",
                                        size: "mini"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row[column.prop] === "0"
                                              ? "异常"
                                              : scope.row[column.prop] === "1"
                                              ? "正常"
                                              : "-"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "confirm_result"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row[column.prop] === "正常"
                                            ? "success"
                                            : scope.row[column.prop] === "异常"
                                            ? "danger"
                                            : "warning",
                                        size: "mini"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row[column.prop] || "未确认"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "confirm_person"
                                ? [
                                    scope.row[column.prop]
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(scope.row[column.prop]) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _c("span", [_vm._v("-")])
                                  ]
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row[column.prop] || "-")
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    width: "120",
                    fixed: "right",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "top",
                                width: "200",
                                trigger: "click",
                                "popper-class": "confirm-popover"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "popover-content" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleCheck(
                                            scope.row,
                                            "异常"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("异常")]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "reference",
                                    type: "text",
                                    size: "small",
                                    disabled:
                                      scope.row.confirm_person !== null &&
                                      scope.row.confirm_result !== null
                                  },
                                  slot: "reference"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        scope.row.confirm_result === "异常"
                                          ? "已经标记异常"
                                          : "标记异常"
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "600px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }